import React from 'react'
import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { TrendIndicator } from './TrendIndicator'

interface MetricCardProps {
  title: string
  value: string | number
  icon: LucideIcon
  trend?: {
    value: number
    isPositive: boolean
  }
  iconColor?: string
  iconBgColor?: string
  className?: string
}

export function MetricCard({
  title,
  value,
  icon: Icon,
  trend,
  iconColor = 'text-tco-blue',
  iconBgColor = 'bg-tco-blue-100',
  className,
}: MetricCardProps) {
  return (
    <div
      className={cn(
        'bg-card rounded-xl border border-border p-6 hover-lift hover:shadow-card-hover transition-all duration-300',
        className
      )}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-2">{title}</p>
          <div className="flex items-end gap-3">
            <p className="text-3xl font-bold text-foreground">{value}</p>
            {trend && <TrendIndicator value={trend.value} isPositive={trend.isPositive} />}
          </div>
        </div>
        <div className={cn('p-3 rounded-xl', iconBgColor)}>
          <Icon className={cn('w-6 h-6', iconColor)} />
        </div>
      </div>
    </div>
  )
}


